// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__TVkwN","dragIcon":"Choice_dragIcon__UMsVE","left":"Choice_left__uw_y6","input":"Choice_input__2-gHb"};